import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 1 }

import { computed } from "vue";

type Props = {
  buttonText: string;
  isLoading: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireButtonNext',
  props: {
    buttonText: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const buttonIsLoading = computed(() => props.isLoading);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: buttonIsLoading.value,
    class: _normalizeClass(["bg-[#393840] border border-[#393840] w-[150px] rounded-primary-radius p-3 flex items-center justify-center text-white text-base leading-5 tracking-[0.01rem] font-semibold", `${buttonIsLoading.value ? 'cursor-wait' : ''}`])
  }, [
    (buttonIsLoading.value)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          width: "16",
          height: "16",
          viewBox: "0 0 14 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          class: _normalizeClass(`${buttonIsLoading.value ? 'animate-spin' : ''}`)
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("path", {
            d: "M5.50024 11H1.75024V14.75M8.50024 5H12.2502V1.25M1.4375 5.75255C1.85801 4.71175 2.56207 3.80978 3.46966 3.14917C4.37724 2.48856 5.45289 2.09564 6.57256 2.01538C7.69223 1.93512 8.81129 2.17055 9.80382 2.69496C10.7963 3.21937 11.6212 4.0119 12.1858 4.98209M12.5634 10.2478C12.1429 11.2886 11.4388 12.1906 10.5312 12.8512C9.62367 13.5118 8.54912 13.9042 7.42944 13.9845C6.30977 14.0647 5.18979 13.8293 4.19727 13.3049C3.20474 12.7805 2.37936 11.9881 1.8147 11.0179",
            stroke: "white",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1)
        ]))], 2))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.buttonText), 1))
  ], 10, _hoisted_1))
}
}

})